var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconKeluar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.3757 8.70949L15.1623 4.49609L13.9595 5.70308L17.6197 9.36321H5.63232V11.0656H17.6197L13.9595 14.7257L15.1631 15.9293L19.3765 11.7159C19.5742 11.5183 19.731 11.2837 19.838 11.0255C19.9449 10.7673 20 10.4905 20 10.211C20 9.9315 19.9449 9.65474 19.838 9.39652C19.731 9.13831 19.5742 8.9037 19.3765 8.70609L19.3757 8.70949Z",
    fill: "#010101"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.91709 17.875C8.91709 18.1008 8.82741 18.3173 8.66778 18.4769C8.50815 18.6365 8.29164 18.7262 8.06589 18.7262H2.55358C2.32783 18.7262 2.11132 18.6365 1.95169 18.4769C1.79206 18.3173 1.70238 18.1008 1.70238 17.875V2.55358C1.70238 2.32783 1.79206 2.11132 1.95169 1.95169C2.11132 1.79206 2.32783 1.70238 2.55358 1.70238H8.06589C8.29164 1.70238 8.50815 1.79206 8.66778 1.95169C8.82741 2.11132 8.91709 2.32783 8.91709 2.55358V7.09298H10.6195V2.55358C10.6195 1.87633 10.3504 1.22681 9.87155 0.747925C9.39266 0.269037 8.74314 0 8.06589 0L2.55358 0C1.87633 0 1.22681 0.269037 0.747925 0.747925C0.269037 1.22681 0 1.87633 0 2.55358L0 17.875C0 18.5523 0.269037 19.2018 0.747925 19.6807C1.22681 20.1596 1.87633 20.4286 2.55358 20.4286H8.06589C8.74314 20.4286 9.39266 20.1596 9.87155 19.6807C10.3504 19.2018 10.6195 18.5523 10.6195 17.875V13.3356H8.91709V17.875Z",
    fill: "#010101"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconKeluar);
export default __webpack_public_path__ + "static/media/icon-keluar.4fa2ef904f225edac37dd490eb9c5bab.svg";
export { ForwardRef as ReactComponent };